import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { DialogService } from 'src/app/services/dialog.service';
import { CerereTypeService } from './cerere-type.service';

import { AddCerereTypeComponent } from './add-cerere-type/add-cerere-type.component';
import { EditCerereTypeComponent } from './edit-cerere-type/edit-cerere-type.component';
import { CerereTypeFunctieManagementComponent } from './cerere-type-functie-management/cerere-type-functie-management.component';
import { helper } from 'src/environments/helper';
import { Observable, Subject, finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { AssignmentDialogData } from './cerere-type-functie-assignment.interface';

import { CommonService } from 'src/app/services/common.service';

import { NotificationService } from 'src/app/services/notification.service';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
    selector: 'app-request-types',
    templateUrl: './cerere-type.component.html',
    styleUrls: ['./cerere-type.component.scss'],
})
export class CerereTypeComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;
    token!: string;
    isLoading = false;

    showCard = false;
    activeValue: string = '-1';
    publicValue: string = '-1';

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    directiiActive$: any = [];

    dtLink =
        environment.interop.basePath +
        environment.interop.dgaspc.nomenclatoare.cerereType.listDT;
    onSelectionChange(event: any): void {
        this.activeValue = event.target.value;
        this.publicValue = event.target.value;
    }
    resetForm() {
        this.activeValue = '-1';
        this.publicValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private notificationService: NotificationService,
        private dialogService: DialogService,
        private requestTypesService: CerereTypeService,
        private commonService: CommonService,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.loadDirectiiActive();
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.active = this.activeValue;
                dataTablesParameters.public = this.publicValue;
                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                    width: '20px',
                },
                {
                    title: 'Nume',
                    data: 'name',
                    width: '300px',
                },
                {
                    title: 'Slug',
                    data: 'slug',
                    width: '200px',
                },
                {
                    title: 'ID indoc',
                    data: 'indoc_id',
                    width: '100px',
                    render: (data: any, type: any, row: any) => {
                        const indoc_id = row.indoc_id ? row.indoc_id : 'n/a'
                        return `
                            <div>${row.indoc_id ? row.indoc_id : 'n/a'}</div>
                            </br>
                            <div>${row.indoc_name ? row.indoc_name : 'n/a'}</div>
                        `
                    }
                },
                {
                    title: 'Asignări Funcții',
                    data: 'functie_assignments',
                    orderable: false,
                    // width: '300px',
                    render: (data: any, type: any, row: any) => {
                        if (!row.functie_assignments || !row.functie_assignments.has_assignments) {
                            return '<span class="text-muted">Nu sunt asignări</span>';
                        }

                        const summary = row.functie_assignments.summary;
                        const count = row.functie_assignments.count;

                        return `
                            <div class="assignment-summary">
                                <span class="badge bg-primary mb-1">${count} asignări</span>
                                <div class="assignment-details small">${summary}</div>
                            </div>
                        `;
                    }
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    width: '150px',
                    render: (row: any) => {
                        return `
                        <div class="d-flex align-center justify-content-left">
                            <button class="action-btn edit me-1" title="Editează">
                                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                            </button>
                            <button class="action-btn manage-assignments signatures me-1" title="Gestionează Asignări">
                                <img class="btn-img" src="../../../../assets/icons/setari-white.svg" alt="manage assignments"/>
                            </button>
                            <button class="action-btn delete me-1" title="Șterge">
                                <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
                            </button>
                        </div>
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const manageAssignmentsIcon = lastTd?.querySelector('.manage-assignments') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'dgaspc-module.settings.tip-cerere.update'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (manageAssignmentsIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'dgaspc-module.settings.tip-cerere.update'
                        )
                    ) {
                        manageAssignmentsIcon.style.display = 'none';
                    }
                    manageAssignmentsIcon.addEventListener('click', () => {
                        this.openManageAssignmentsDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'dgaspc-module.settings.tip-cerere.delete'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteCerere(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    deleteCerere(id: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.delete,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: this.helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.requestTypesService.deleteRequestType(id).subscribe(
                    () => {
                        this.rerenderDT();
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.deleted,
                            text: 'Tip Cerere ștearsă cu succes.',
                            icon: 'success',
                            confirmButtonText: this.helper.swalTextConfig.buttonLabels.ok,
                        });
                    },
                    (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    }
                );
            }
        });
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddCerereTypeComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Tip Cerere adaugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditCerereTypeComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Tip Cerere actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    loadDirectiiActive() {
        // this.isLoading = true;
        // this.directiiActive$ = this.commonService.getDirectiiActive().pipe(
        //     map((results: any) => [this.defaultParameter, ...results]),
        //     finalize(() => (this.isLoading = false))
        // );
    }

    clearCache() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.cleanCache,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: this.helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.requestTypesService.clearCache().subscribe(
                    () => {
                        this.rerenderDT();
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.deleted,
                            text: this.helper.swalTextConfig.generalMessages.cleanCacheSuccess,
                            icon: 'success',
                            confirmButtonText: this.helper.swalTextConfig.buttonLabels.ok,
                        });
                    },
                    (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    }
                );
            }
        });
    }

    openManageAssignmentsDialog(data: any) {
        // Fetch existing assignments first
        this.requestTypesService.getFunctieAssignments(data.id).subscribe(
            (response: any) => {
                const dialogData: AssignmentDialogData = {
                    cerereTypeId: data.id,
                    cerereTypeName: data.name,
                    existingAssignments: response.success ? response.data.assignments : []
                };

                const dialogRef = this.dialog.open(CerereTypeFunctieManagementComponent, {
                    width: '1000px',
                    maxWidth: '95vw',
                    maxHeight: '90vh',
                    disableClose: false,
                    data: dialogData
                });

                dialogRef.afterClosed().subscribe((result: boolean) => {
                    if (result) {
                        // Refresh DataTable to show updated assignments
                        this.rerenderDT();
                        Swal.fire({
                            title: 'Success',
                            text: 'Asignările au fost actualizate cu succes.',
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                        });
                    }
                });
            },
            (error: any) => {
                console.error('Error fetching assignments:', error);
                Swal.fire({
                    title: 'Eroare',
                    text: 'Nu s-au putut încărca asignările existente.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        );
    }
}
